import CloseIcon from '@mui/icons-material/Close';
import { Box, IconButton, List, ListItem, Typography } from '@mui/material';
import dayjs from 'dayjs';
import { useAppSelector } from '../../../../../../../store/hooks';
import zeplinColor from '../../../../../../../theme/Color';
import CustomCard from '../../../../../../shared/CustomCard/CustomCard';
import CustomModal from '../../../../../../shared/CustomModal/CustomModal';

type MoreModalProps = {
  open: boolean;
  onClose: () => void;
  events: any[];
  date: any;
  hour: any;
  onSelectEvent: any;
};

export const MoreEventsModal = ({
  open,
  onClose,
  events,
  date,
  hour,
  onSelectEvent,
}: MoreModalProps) => {
  const { colors } = useAppSelector((state) => state.calendar);

  return (
    <CustomModal open={open} handleClose={onClose}>
      <Box
        onClick={(e) => e.stopPropagation()}
        sx={{
          display: 'flex',
          height: '100%',
          justifyContent: 'center',
          flexDirection: 'column',
          alignItems: 'center',
          outline: 'none',
        }}
      >
        <CustomCard
          styles={{
            borderRadius: '14px',
            padding: '16px',
            backgroundColor: zeplinColor.Neutral1,
            width: '400px',
            maxHeight: '400px',
            overflowY: 'auto',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              flexDirection: 'column',
              marginBottom: '16px',
            }}
          >
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
              }}
            >
              <Typography
                variant='heading3'
                sx={{ colo: zeplinColor.BasicBlack, marginBottom: '12px' }}
              >
                {events.length} Overlapping Meetings
              </Typography>
              <IconButton onClick={onClose} size='small'>
                <CloseIcon />
              </IconButton>
            </Box>
            <Typography variant='body3' sx={{ color: zeplinColor.Neutral9 }}>
              These events share the same time slot. Click an event for details or to join
            </Typography>
          </Box>

          <List sx={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
            {events.map((ev) => {
              const color = colors[ev.selectedCalendar || 'huddle'] || zeplinColor.Brand1;
              return (
                <ListItem
                  disablePadding
                  key={ev.id}
                  onClick={(e) => {
                    onSelectEvent(e, ev);
                    onClose();
                  }}
                  sx={{
                    border: `1px solid ${zeplinColor.Neutral5}`,
                    borderRadius: '20px',
                    cursor: 'pointer',
                    transition: 'all 0.2s ease',
                    '&:hover': {
                      backgroundColor: zeplinColor.Neutral2,
                      borderColor: zeplinColor.Neutral6,
                    },
                  }}
                >
                  <Box
                    sx={{ display: 'flex', alignItems: 'center', p: '16px 20px', width: '100%' }}
                  >
                    <Box
                      sx={{
                        width: '4px',
                        height: '32px',
                        backgroundColor: color,
                        borderRadius: '4px',
                        marginRight: '16px',
                      }}
                    />

                    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                      <Typography
                        variant='body3'
                        sx={{
                          fontWeight: 500,
                          color: zeplinColor.BasicBlack,
                          lineHeight: 1.2,
                        }}
                      >
                        {ev.meetingName}
                      </Typography>
                      <Typography
                        variant='label1'
                        sx={{
                          color: zeplinColor.Neutral8,
                        }}
                      >
                        {`${dayjs(ev.start).format('hh:mma')} - ${dayjs(ev.end).format('hh:mma')}`}
                      </Typography>
                    </Box>
                  </Box>
                </ListItem>
              );
            })}
          </List>
        </CustomCard>
      </Box>
    </CustomModal>
  );
};
